<template>
  <section
    class="md:mt-8 m-auto bg-black pt-6 px-2 md:px-10 pb-5 shadow-black shadow-xl max-w-[1400px]"
  >
    <div
      id="message"
      class="h-[100vh] w-full text-white font-electro text-[24px] flex flex-col text-center pt-16 md:pt-4"
    >
      <p>404</p>
      <p class="mt-4">Page Not Found</p>
      <p>Oops, we can't find the page you requested!</p>
      <router-link to="/" class="mt-8 hover:text-[#FF0000]">
        <span>Go back home</span>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped></style>
